import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { BasicRegulatoryDocumentParaFieldsFragmentDoc } from '../../../fragments/basicFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulationResultCardDocumentsQueryVariables = Types.Exact<{
  regulation: Types.Scalars['ID'];
}>;


export type GetRegulationResultCardDocumentsQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string }> } | null };

export type GetSearchMoreParagraphsTocQueryVariables = Types.Exact<{
  regulatoryDocumentID: Types.Scalars['ID'];
  paraId: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type GetSearchMoreParagraphsTocQuery = { __typename?: 'Query', searchMoreParagraphsTOC: Array<{ __typename?: 'RegulatoryDocumentParagraph', level: number, id: string, enumeration: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, position: number, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', assetId?: string | null, bounds?: Array<number> | null, csvContent?: string | null, isHeader: boolean, page: number, text?: string | null, textPosition?: Types.TextPosition | null, type: Types.ParagraphElementType, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, originalFileName?: string | null, uri: any } | null }> }> };


export const GetRegulationResultCardDocumentsDocument = gql`
    query GetRegulationResultCardDocuments($regulation: ID!) {
  regulation(id: $regulation) {
    regulatoryDocuments {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRegulationResultCardDocumentsQuery__
 *
 * To run a query within a React component, call `useGetRegulationResultCardDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationResultCardDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationResultCardDocumentsQuery({
 *   variables: {
 *      regulation: // value for 'regulation'
 *   },
 * });
 */
export function useGetRegulationResultCardDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationResultCardDocumentsQuery, GetRegulationResultCardDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationResultCardDocumentsQuery, GetRegulationResultCardDocumentsQueryVariables>(GetRegulationResultCardDocumentsDocument, options);
      }
export function useGetRegulationResultCardDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationResultCardDocumentsQuery, GetRegulationResultCardDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationResultCardDocumentsQuery, GetRegulationResultCardDocumentsQueryVariables>(GetRegulationResultCardDocumentsDocument, options);
        }
export type GetRegulationResultCardDocumentsQueryHookResult = ReturnType<typeof useGetRegulationResultCardDocumentsQuery>;
export type GetRegulationResultCardDocumentsLazyQueryHookResult = ReturnType<typeof useGetRegulationResultCardDocumentsLazyQuery>;
export type GetRegulationResultCardDocumentsQueryResult = Apollo.QueryResult<GetRegulationResultCardDocumentsQuery, GetRegulationResultCardDocumentsQueryVariables>;
export const GetSearchMoreParagraphsTocDocument = gql`
    query GetSearchMoreParagraphsTOC($regulatoryDocumentID: ID!, $paraId: [ID!]!) {
  searchMoreParagraphsTOC(
    paraId: $paraId
    regulatoryDocumentID: $regulatoryDocumentID
  ) {
    ...BasicRegulatoryDocumentParaFields
  }
}
    ${BasicRegulatoryDocumentParaFieldsFragmentDoc}`;

/**
 * __useGetSearchMoreParagraphsTocQuery__
 *
 * To run a query within a React component, call `useGetSearchMoreParagraphsTocQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchMoreParagraphsTocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchMoreParagraphsTocQuery({
 *   variables: {
 *      regulatoryDocumentID: // value for 'regulatoryDocumentID'
 *      paraId: // value for 'paraId'
 *   },
 * });
 */
export function useGetSearchMoreParagraphsTocQuery(baseOptions: Apollo.QueryHookOptions<GetSearchMoreParagraphsTocQuery, GetSearchMoreParagraphsTocQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchMoreParagraphsTocQuery, GetSearchMoreParagraphsTocQueryVariables>(GetSearchMoreParagraphsTocDocument, options);
      }
export function useGetSearchMoreParagraphsTocLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchMoreParagraphsTocQuery, GetSearchMoreParagraphsTocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchMoreParagraphsTocQuery, GetSearchMoreParagraphsTocQueryVariables>(GetSearchMoreParagraphsTocDocument, options);
        }
export type GetSearchMoreParagraphsTocQueryHookResult = ReturnType<typeof useGetSearchMoreParagraphsTocQuery>;
export type GetSearchMoreParagraphsTocLazyQueryHookResult = ReturnType<typeof useGetSearchMoreParagraphsTocLazyQuery>;
export type GetSearchMoreParagraphsTocQueryResult = Apollo.QueryResult<GetSearchMoreParagraphsTocQuery, GetSearchMoreParagraphsTocQueryVariables>;